module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"invitationTip":"Пройти онлайн-собеседование на эту вакансию возможно только по приглашению работодателя.","salary":"з/п"}}')
  delete Component.options._Ctor
}
